import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=3da54562"
import script from "./LinkList.vue?vue&type=script&lang=js"
export * from "./LinkList.vue?vue&type=script&lang=js"
import style0 from "./LinkList.vue?vue&type=style&index=0&id=3da54562&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports